
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tenant-screening-services/addresses",
      function () {
        return require("private-next-pages/tenant-screening-services/addresses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tenant-screening-services/addresses"])
      });
    }
  